import React from 'react';
import { SvgIcon } from '@mui/material';

const CourseIcon = ({ sx, ...props }) => {
    return (
        <SvgIcon
            sx={sx}
            viewBox="0 0 18 16"
            {...props}
        >
            <path d="M17.5088 1.89875V12.3025C17.5088 13.1512 16.8175 13.93 15.9688 14.035L15.6975 14.07C14.2625 14.2625 12.2413 14.8575 10.6138 15.54C10.045 15.7762 9.41504 15.3475 9.41504 14.7262V2.555C9.41504 2.23125 9.59879 1.93375 9.88754 1.77625C11.4888 0.91 13.9125 0.14 15.5575 0H15.61C16.66 0 17.5088 0.84875 17.5088 1.89875Z" fill="currentColor"/>
            <path d="M7.63 1.77625C6.02875 0.91 3.605 0.14 1.96 0H1.89875C0.84875 0 0 0.84875 0 1.89875V12.3025C0 13.1512 0.69125 13.93 1.54 14.035L1.81125 14.07C3.24625 14.2625 5.2675 14.8575 6.895 15.54C7.46375 15.7762 8.09375 15.3475 8.09375 14.7262V2.555C8.09375 2.2225 7.91875 1.93375 7.63 1.77625ZM2.63375 4.4275H4.6025C4.96125 4.4275 5.25875 4.725 5.25875 5.08375C5.25875 5.45125 4.96125 5.74 4.6025 5.74H2.63375C2.275 5.74 1.9775 5.45125 1.9775 5.08375C1.9775 4.725 2.275 4.4275 2.63375 4.4275ZM5.25875 8.365H2.63375C2.275 8.365 1.9775 8.07625 1.9775 7.70875C1.9775 7.35 2.275 7.0525 2.63375 7.0525H5.25875C5.6175 7.0525 5.915 7.35 5.915 7.70875C5.915 8.07625 5.6175 8.365 5.25875 8.365Z" fill="currentColor"/>
        </SvgIcon>
    );
};

export default CourseIcon;